<template>
  <div>
    <NavBtns></NavBtns>

    <!--顯示模式切換鈕-->
    <section id="loc_contentbtn">
      <div class="allbtnbox">
        <label>
          <div class="btn2" :class="[ui_mode]">
            <i class="far fa-image">
              <div class="text">{{ $t('message.lo_photo_mode') }}</div>
            </i>
            <input type="radio" v-model="ui_mode" value="photo" />
          </div>
        </label>
        <label>
          <div class="btn1" :class="[ui_mode]">
            <i class="fas fa-map-marked-alt">
              <div class="text">{{ $t('message.lo_map_mode') }}</div>
            </i>
            <input type="radio" v-model="ui_mode" value="map" />
          </div>
        </label>
      </div>
    </section>

    <!--地點圖文資料-->
    <section
      id="loc_content1"
      :class="[ui_mode]"
      v-if="!(is_offline || is_no_data)"
    >
      <div
        class="allbox"
        v-for="(co_unit, co_unit_idx) in co_units"
        v-bind:key="co_unit_idx"
      >
        <div class="titlebox wow">
          <i class="fas fa-map-marker-alt"></i>
          <div class="title">{{ co_unit['co_unit_i18n'][$i18n.locale] }}</div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div
              v-for="(site, site_idx) in co_unit['sites']"
              class="col-xl-6"
              v-bind:key="site_idx"
            >
              <div class="row">
                <div class="col-xl-7 col-md-7">
                  <div
                    class="box1"
                    @click="vShowBigImg(site['site_img']['img_pc'])"
                  >
                    <img
                      class="img-fluid"
                      v-if="!site['site_img']['img_mobile_err']"
                      :src="site['site_img']['img_mobile']"
                      :alt="site['site_no']"
                      @error="vSetMobileImgError(co_unit_idx, site_idx)"
                    />
                    <!--圖片載入異常時顯示-->
                    <div
                      class="offlinebox"
                      :class="{ show: site['site_img']['img_mobile_err'] }"
                    >
                      <div class="offallbox">
                        <div class="imgbox">
                          <img
                            class="img-fluid"
                            src="../assets/images/offline.svg"
                            alt="offline"
                          />
                        </div>
                        <div class="text">
                          {{ $t('message.pb_no_picture') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 col-md-5">
                  <div class="textallbox wow">
                    <div class="lotitle">
                      {{ site['site_i18n'][$i18n.locale] }}
                    </div>
                    <div class="textbox">
                      <p>
                        {{ $t('message.lo_biz_time_title')
                        }}<span
                          v-html="site['biz_time_i18n'][$i18n.locale]"
                        ></span>
                      </p>
                      <p>
                        {{ $t('message.lo_addr_title')
                        }}<span v-html="site['addr_i18n'][$i18n.locale]"></span>
                      </p>
                      <p>
                        {{ $t('message.lo_location_title')
                        }}{{ site['loc_desc_i18n'][$i18n.locale] }}
                      </p>
                      <p
                        v-for="(locker, locker_idx) in site['lockers_type']"
                        v-bind:key="locker_idx"
                      >
                        {{ $t('message.qs_locker_size_' + locker.size) }}：{{
                          $t('message.lo_locker_num', { num: locker.total })
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--大圖視窗-->
      <div class="imgbig" :class="{ show: show_big_img }">
        <div class="blackbox" @click="vShowBigImg('')">
          <div class="box1">
            <img
              v-if="!big_img_err"
              class="img-fluid"
              :src="big_img_src"
              @error="vSetPCImgError()"
            />
            <!--圖片載入異常時顯示-->
            <div class="offlinebox" :class="{ show: big_img_err }">
              <div class="offallbox">
                <div class="imgbox">
                  <img
                    class="img-fluid"
                    src="../assets/images/offline.svg"
                    alt="offline"
                  />
                </div>
                <div class="text">{{ $t('message.pb_no_picture') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--google map-->
    <section id="loc_content2" v-if="ui_mode == 'map'">
      <div class="allbtn" v-if="!(is_offline || is_no_map)">
        <i class="far fa-hand-point-down"></i>
        <span>{{ $t('message.lo_check_all_map') }}</span>
      </div>
      <div class="map" v-if="!(is_offline || is_no_map)">
        <div class="container-fluid">
          <div class="iframe-rwd">
            <iframe :src="site_map"></iframe>
          </div>
        </div>
      </div>
    </section>

    <!--離線提示-->
    <section id="loc_offline">
      <div class="container-fulid">
        <div class="col-xl-12">
          <div
            class="offlinebox"
            :class="{ show: is_offline || is_no_map || is_no_data }"
          >
            <div class="allbox">
              <div class="imgbox">
                <img
                  class="img-fluid"
                  src="../assets/images/offline.svg"
                  alt="offline"
                />
              </div>
              <div class="text">
                {{
                  is_offline
                    ? $t('message.pb_offline')
                    : is_no_map
                    ? $t('message.lo_no_map')
                    : $t('message.lo_no_data')
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';
import { WOW } from 'wowjs';

// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import GzFooter from '@/components/GzFooter.vue';
import Public from '@/scripts/public';

export default {
  name: 'Location',
  components: {
    NavBtns,
    GzFooter,
  },
  data: function () {
    return {
      sites_map_api: Public.appGetAPIURL('loc-map'),
      sites_graphic_api: Public.appGetAPIURL('loc-photo'),
      //控制畫面目前顯示地圖 或 圖文資料
      ui_mode: 'photo',
      //google map src
      site_map: null,
      //站點資料
      co_units: [
        // {
        // 	"co_unit_i18n" : {
        // 		"zh-TW" : "戲苑科技",
        // 		"en-US" : "GameZone Techology"
        // 	},
        // 	"sites" : [
        // 		{
        // 			"site_i18n" : {
        // 				"zh-TW" : "戲苑科技",
        // 				"en-US" : "GameZone Techology"
        // 			},
        // 			"site_no" : "001",
        // 			"biz_time_i18n" : {
        // 				"zh-TW" : "09:00~18:00",
        // 				"en-US" : "09:00~18:00"
        // 			},
        // 			"addr_i18n" : {
        // 				"zh-TW" : "406 台中市北屯區豐樂路 16-6號",
        // 				"en-US" : "No. 16-6, Fengle Rd., Beitun Dist., Taichung City 406, Taiwan (R.O.C.)"
        // 			},
        // 			"loc_desc_i18n" : {
        // 				"zh-TW" : "總公司",
        // 				"en-US" : "總公司"
        // 			},
        // 			"site_img" : {
        // 				"img_pc" : "./assets/images/location_default.jpg",
        // 				"img_mobile" : "./assets/images/location_defaults.jpg"
        // 			},
        // 			"lockers_type" : [
        // 				{
        // 					"size" : "M",
        // 					"total": 0
        // 				},
        // 				{
        // 					"size" : "L",
        // 					"total": 0
        // 				},
        // 				{
        // 					"size" : "S",
        // 					"total": 0
        // 				}
        // 			]
        // 		}
        // 	]
        // }
      ],
      //顯示大圖
      show_big_img: false,
      //大圖來源
      big_img_src: '',
      //大圖讀取錯誤註記
      big_img_err: false,
    };
  },
  computed: {
    //網路連線狀態 (地圖適用)
    is_offline: function () {
      var is_show = false;
      //地圖模式
      if (this.ui_mode == 'map') {
        is_show = this.net_offline;

        //圖文模式
      } else if (
        this.ui_mode == 'photo' &&
        this.net_offline &&
        (!this.co_units || this.co_units.length <= 0)
      ) {
        is_show = true;
      }
      return is_show;
      // return false
    },
    //沒有地圖來源
    is_no_map: function () {
      return (
        this.ui_mode == 'map' && (!this.site_map || this.site_map.length <= 0)
      );
      // return false
    },
    //沒有圖文資料
    is_no_data: function () {
      return (
        this.ui_mode == 'photo' && (!this.co_units || this.co_units.length <= 0)
      );
      // return false
    },
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  mounted: function () {
    //動畫處理
    new WOW().init();

    //取得 google map src
    this.vLoadAllMaps();
    //取得所有據點的圖文資料
    this.vLoadSites();
  },
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //取得 google map src
      this.vLoadAllMaps();
      //取得所有據點的圖文資料
      this.vLoadSites();
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
    //從cache / 網路載入 google map
    vLoadAllMaps: function () {
      var ref = this;
      if (!this.sites_map_api || this.sites_map_api.length <= 0) {
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(this.sites_map_api).then((data) => {
        ref.vRenderMap(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(this.sites_map_api).then((data) => {
        ref.vRenderMap(data);
      });
    },
    //設定地圖來源
    vRenderMap: function (map_data) {
      if (map_data && map_data['iframe_map']) {
        this.site_map = map_data['iframe_map'];
      }
    },
    //從cache / 網路載入圖文資料
    vLoadSites: function () {
      var ref = this;
      if (!this.sites_graphic_api || this.sites_graphic_api.length <= 0) {
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(this.sites_graphic_api).then(
        (data) => {
          ref.vRenderSites(data);
        }
      );

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(this.sites_graphic_api).then(
        (data) => {
          ref.vRenderSites(data);
        }
      );
    },
    //依資料重新渲染畫面
    vRenderSites: function (site_data) {
      var i, j, s;
      if (site_data && site_data.length > 0) {
        /*依前端需求重整副櫃尺寸代碼
              後台 => S:充電櫃 / M:小櫃 / L:大櫃
              前台 => M:充電櫃 / S:小櫃 / L:大櫃
			*/
        for (i = 0; i < site_data.length; i++) {
          for (j = 0; j < site_data[i]['sites'].length; j++) {
            for (
              s = 0;
              s < site_data[i]['sites'][j]['lockers_type'].length;
              s++
            ) {
              if (site_data[i]['sites'][j]['lockers_type'][s]['size'] == 'M') {
                site_data[i]['sites'][j]['lockers_type'][s]['size'] = 'S';
              } else if (
                site_data[i]['sites'][j]['lockers_type'][s]['size'] == 'S'
              ) {
                site_data[i]['sites'][j]['lockers_type'][s]['size'] = 'M';
              }
            }
          }
        }
        //依 UI 需求，依副櫃尺寸排序資料
        for (i = 0; i < site_data.length; i++) {
          for (j = 0; j < site_data[i]['sites'].length; j++) {
            site_data[i]['sites'][j]['lockers_type'] = site_data[i]['sites'][j][
              'lockers_type'
            ].sort(function (a, b) {
              var a_sort = Public.pbLockerTypeSort(a.size);
              var b_sort = Public.pbLockerTypeSort(b.size);
              return a_sort > b_sort ? 1 : -1;
            });
            //為圖片設定小圖載入成功與否的註記 (未設定小圖資料時，一律將註記設為載入失敗)
            if (!site_data[i]['sites'][j]['site_img']['img_mobile']) {
              site_data[i]['sites'][j]['site_img']['img_mobile_err'] = true;
            } else {
              site_data[i]['sites'][j]['site_img']['img_mobile_err'] = false;
            }
          }
        }
      }
      //強制 render 資料
      for (i = this.co_units.length - 1; i >= 0; i--) {
        this.co_units.pop();
      }
      this.co_units = site_data && site_data.length > 0 ? site_data : [];
    },
    //當圖文模式 / 小圖載入錯誤時
    vSetMobileImgError: function (co_unit_idx, site_idx) {
      if (
        this.co_units[co_unit_idx] &&
        this.co_units[co_unit_idx]['sites'] &&
        this.co_units[co_unit_idx]['sites'][site_idx] &&
        this.co_units[co_unit_idx]['sites'][site_idx]['site_img']
      ) {
        this.co_units[co_unit_idx]['sites'][site_idx]['site_img'][
          'img_mobile_err'
        ] = true;
      }
      //強制 render 畫面
      var origin_data = this.co_units;
      this.co_units = [];
      this.co_units = origin_data;
    },
    //當圖文模式 / 大圖載入錯誤時
    vSetPCImgError: function () {
      this.big_img_err = true;
    },
    //顯示大圖
    vShowBigImg: function (img_path) {
      this.big_img_err = false;
      this.big_img_src = img_path && img_path.length > 0 ? img_path : '';
      this.show_big_img = !this.show_big_img;
      //關閉視窗時
      if (!this.show_big_img) {
        this.big_img_err = false;
      }
    },
  },
  watch: {
    ui_mode: function () {
      $('html , body').animate({ scrollTop: 0 }, 500);
    },
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
